<template lang="pug" id="idea-modal">
.modal-backdrop(role="dialog" @mousedown.stop="close")
  .new-idea-modal.column(@mousedown.stop @click.stop)
    .wrapper.column.flex-1(style="min-height: fit-content;")
      //- HEADER
      .header.row.center.between
        div {{ t.suggest_idea }}
        .close.icon.row.center(@click="close")
          font-awesome-icon(icon="times")
      //- Content
      .content.column.between.flex-1
        form.column
          select(v-model="box_id")
            option(:value="undefined" disabled) {{ t.category }}*
            option(v-for="box,id in $root.account_boxes" :key="id" :value="id") {{ box.title }}
          textarea.title(v-model="title" :placeholder="t.title + '*'")
          textarea.description(v-model="description" :placeholder="t.description")
          date-picker.row.center.left(@select="publication_date = $event" :date="publication_date" :metadata="{date_format: d => d.format('%d %b %Y', $root.lang) }" :domain="[new Date().format('%Y-%m-%d'), new Date().advance('3 years').format('%Y-%m-%d')]")
            template(slot="date" slot-scope="{ displayed_date, selected_date}")
              .row.center.left
                .icon
                  svg-icon(name="calendar")
                div(v-if="displayed_date" style="font-weight: bold;") {{ displayed_date }}
                div(v-else style="font-weight: bold;") {{ t.wanted_publication_date }}
          button.upload.primary.row.center.left(@mousedown.stop @click.stop.prevent="click_upload" :class="{disabled: $root.uploading}")
            .icon
              svg-icon(name="cloud-upload")
            div {{ t.add_attachment }}
          input(@mousedown.stop @click.stop type="file" id="file" ref="file" @change="upload_images($event)" hidden multiple)
          .image.row.center.left(v-for="image in images" @click="images = images.filter(d => d!==image)")
            .icon(style="margin-right: 6px;")
              fa-icon(icon="image" size="16px")
            div {{ image.split('/').last() }}
            .icon(style="margin-left: auto;")
              fa-icon(icon="times" size="16px")
        .row.center.between
          div(style="font-size: 12px;") *{{ t.required_field }}
          button(style="font-weight: bold;" :class="submit_button_class" @click="submit") {{ t.submit }}
</template>
<script>
export default {
  props: ['start_box_id'],
  data() {
    return {
      box_id: null,
      title: null,
      publication_date: null,
      description: null,
      images: [],
    }
  },
  mounted() {
    this.box_id = this.start_box_id
  },
  watch: {},
  computed: {
    pretty_text() {
      // return this.data.text.replace(/#(\S+)/g, '<u>#$1</u>').replace(/@(\S+)/g, '<u>@$1</u>').replace(/(?:\r\n|\r|\n)/g, '<br />');
    },
    submit_button_class() {
      if (!this.title || !this.box_id) return 'disabled'
      return 'green'
    },
  },
  methods: {
    click_upload() {
      document.querySelector('#file').click()
    },
    close() {
      this.$root.modal = null
    },
    submit() {
      const { box_id, title, description, publication_date, images } = this
      this.$root
        .new_idea({ box_id, title, description, publication_date, images })
        .then(() => this.close())
    },
    upload_images(ev) {
      this.$root.multiple_file_upload(ev).then(r => (this.images = this.images.concat(r)))
    },
  },
}
</script>
<style>
.new-idea-modal {
  --width: 480px;
  position: fixed;
  padding: 16px;
  box-shadow: var(--box-shadow);
  border-radius: 0 16px 16px 16px;
  background: white;
  left: calc(50vw - calc(var(--width) / 2));
  top: calc(50vh - 260px);
  width: var(--width);
  height: 520px;
  z-index: 10;
}
.mobile:not(.laptop) .new-idea-modal {
  --width: 100vw;
  left: 0;
  top: var(--nav-top-height);
  --full-height: calc(var(--vh) * 100);
  max-height: calc(calc(var(--full-height) - var(--nav-top-height)) - 8px);
}
.new-idea-modal .header {
  color: var(--grey);
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 16px;
}
.new-idea-modal .header .close {
  width: 32px;
  height: 32px;
  padding: 6px;
  border-radius: 50%;
  border: 1px solid var(--grey);
  cursor: pointer;
}

.new-idea-modal select,
.new-idea-modal textarea {
  margin-bottom: 16px;
  min-height: 40px;
  font-weight: bold;
  resize: none;
  font-size: 16px;
}

.new-idea-modal textarea {
  border-radius: 0 16px 16px 16px;
  background: var(--background);
  padding: 8px 16px;
}
.new-idea-modal textarea.title {
  height: 64px;
}
.new-idea-modal textarea.description {
  height: 120px;
}
.new-idea-modal .date-picker {
  min-width: 100%;
  border-radius: 16px;
  margin-bottom: 16px;
}
.new-idea-modal .date-picker .date:hover {
  background: none;
}
.new-idea-modal .date-picker .date {
  width: 100%;
  padding: 8px 16px;
}
.new-idea-modal .date-picker .icon {
  width: 24px;
  height: 24px;
  margin-right: 16px;
}
.new-idea-modal .upload {
  padding: 8px 16px;
  border-radius: 16px;
  margin-bottom: 8px;
  font-weight: bold;
}
.new-idea-modal .upload .icon {
  width: 24px;
  height: 24px;
  margin-right: 16px;
  fill: white;
}
.new-idea-modal .image {
  background: var(--background);
  width: 70%;
  padding: 4px;
  margin-bottom: 4px;
}
.new-idea-modal .image:hover {
  cursor: pointer;
  background: rgba(0, 0, 0, 0.2);
}
</style>
